import React from "react";
import { formatAmount } from "../utils/formatAmount";
import lightbulb from "../Assets/Icons/lightbulb.png";
const Capital = ({ state, setIsModalOpen, type }) => {
  return (
    <div className="mt-6 w-full">
      <div className=" mx-auto">
        <div className=" text-[36px] leading-[40px] md:text-[54px] md:leading-[59.4px] tracking-[-3.1%] font-[400] text-[#9c9c9e] ">
          Your investment in
          <br />
          <span className=" text-[54px] leading-[59.4px] tracking-[-3.1%] text-[#131E3D] font-[400] ">
            {" "}
            {state?.investment?.property?.name ||
              state?.investment?.name ||
              state?.cycle_details?.name}
          </span>{" "}
        </div>
        {state?.opportunity?.name || state?.business?.name ? (
          <div className="mb-[15px] text-[16px] mt-3 font-[400] text-[#9c9c9e] ">
            by {state?.opportunity?.name || state?.business?.name || "--"}
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className=" mb-[5px]  py-5 text-[16px] font-[500] text-[#131E3D]  ">
        {" "}
        Overview{" "}
      </div>
      <div className="  mb-[20px] w-[100%] md:w-[696px] h-[263px] rounded-[12px] border-[1px] border-[#f2f2f7] flex justify-between flex-col ">
        <div className=" p-5">
          <div className=" text-[14px] font-[400] text-[#9c9c9e] ">Capital</div>
          {/* {state?.break_down &&
          state?.break_down[0]?.type === "investment_loss_calculation" &&
          state?.investment_category?.name?.toLocaleLowerCase() ==
            "exchange traded commodities" ? (
            <>
              <h4 className="text-[32px] font-[500] text-[#131E3D] ">
                <span className="text-[30px] mr-3 text-[#9C9C9E] line-through font-[500]  ">
                  {state?.investment?.currency === "NGR" ||
                  state?.cycle_details?.currency === "NGR"
                    ? "₦"
                    : "$"}
                  {formatAmount(state?.amount)}
                </span>
                {state?.investment?.currency === "NGR" ||
                state?.cycle_details?.currency === "NGR"
                  ? "₦"
                  : "$"}
                {formatAmount(
                  state?.break_down
                    ? state?.break_down[0]?.total_current_investment_value
                    : 0,
                )}
              </h4>
              <div className=" text-[#2CB171] font-[400] text-[14px] ">
                -
                {state?.investment?.currency === "NGR" ||
                state?.cycle_details?.currency === "NGR"
                  ? "₦"
                  : "$"}
                {formatAmount(
                  state?.break_down
                    ? Math.abs(
                        (state?.break_down[0]?.percentage_of_investment_loss *
                          state?.amount) /
                          100,
                      )
                    : 0,
                )}{" "}
                recalculated returns (
                {state?.break_down
                  ? state?.break_down[0]?.percentage_of_investment_loss
                  : 0}
                %)
              </div>
            </>
          ) : ( */}
          <>
            <div className="text-[32px] font-[500] text-[#131E3D] ">
              {state?.investment?.currency === "NGR" ||
              state?.cycle_details?.currency === "NGR"
                ? "₦"
                : "$"}{" "}
              {formatAmount(
                type === "REAL-ESTATE" && state?.investment?.amount_per_unit
                  ? state?.amount * state?.investment?.amount_per_unit
                  : state?.amount,
              )}
            </div>
            {type === "REAL-ESTATE" ? (
              <></>
            ) : state?.investment?.investment_type?.toLocaleLowerCase() ===
                "mudarabah" ||
              state?.cycle_details?.investment_type?.toLocaleLowerCase() ===
                "mudarabah" ? (
              <div className=" text-[#2CB171] font-[400] text-[14px] ">
                Expected returns (
                {`${
                  state?.cycle_details?.roi_range?.min_roi ||
                  state?.investment?.roi_range?.min_roi
                } - ${
                  state?.cycle_details?.roi_range?.max_roi ||
                  state?.investment?.roi_range?.max_roi
                }%`}
                )
              </div>
            ) : (
              <div className=" text-[#2CB171] font-[400] text-[14px] ">
                +
                {state?.investment?.currency === "NGR" ||
                state?.cycle_details?.currency === "NGR"
                  ? "₦"
                  : "$"}
                {formatAmount(
                  (type === "REAL-ESTATE" && state?.investment?.annual_roi
                    ? state?.investment?.annual_roi *
                      state?.amount *
                      state?.investment?.amount_per_unit
                    : state?.investment?.roi
                      ? state?.investment?.roi * state?.amount
                      : state?.cycle_details?.roi * state?.amount) / 100,
                )}{" "}
                expected returns (
                {state?.investment?.roi || state?.cycle_details?.roi}%)
              </div>
            )}
          </>
          {/* )} */}
        </div>
        {type === "REAL-ESTATE" ? (
          <div className="flex p-5 items-center gap-[8px]">
            {false ? (
              <button
                onClick={() => {
                  setIsModalOpen({ modal: "SELL-INITIATED" });
                }}
                className="shadow-sm text-[14px] border-[1.2px] border-[#F2F2F7] font-[500] flex items-center bg-[#FFF] text-[#192851] py-2 px-4 rounded-[8px]"
              >
                Sell Units
              </button>
            ) : (
              <>
                <img src={lightbulb} alt="" className="h-[24px] " />
                <h4 className="font-[400] text-[#9C9C9E] text-base ">
                  You’ll be able to sell when the marketplace is open
                </h4>
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Capital;
